import {Component} from '@angular/core';
import {OverigeKostenComponent} from './overige-kosten/overige-kosten.component';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-beperkt-aftrekbare-kosten',
  templateUrl: './beperkt-aftrekbare-kosten.component.html',
  styleUrls: ['./beperkt-aftrekbare-kosten.component.scss'],
  imports: [
    OverigeKostenComponent
  ]
})
export class BeperktAftrekbareKostenComponent {
}
